import React, {
  useContext,
  useEffect,
  useState,
  useMemo,
  useLayoutEffect,
  useRef,
} from 'react';
import {
  ListItemText,
  Icon,
  IconButton,
  Snackbar,
  Menu,
  MenuItem,
  ListItemIcon,
  Dialog,
  DialogTitle,
  Button,
  DialogActions,
  DialogContent,
  CircularProgress,
  TextField,
  FormControlLabel,
  Checkbox,
  Select,
  InputLabel,
  SelectChangeEvent,
  Popover,
  Typography,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  List,
  ListItem,
  Divider,
  Box,
  Chip,
  Card,
  CardContent,
  Grid,
  Stack,
  Container,
  AppBar,
  Tabs,
  Tab,
  Alert,
} from '@mui/material';
import { blue, green, grey, red } from '@mui/material/colors';
import DeleteIcon from '@mui/icons-material/Delete';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { GetUserListResponse } from 'api/SharedTypes';
import { ProviderProps, UserRole, Icons } from 'services/Utils';
import './UsersList.css';
import { NavRoutes } from 'pages/NavRouter';
import { makeStyles, styled } from '@mui/styles';
import { createApiClient } from 'api/apiClient';
import MoreVert from '@mui/icons-material/MoreVert';
import { FormattedMessage, useIntl } from 'react-intl';
import I18nKey from 'lib/I18nKeys';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import { useMutation } from 'react-query';
import { UserContext, UserContextState } from 'contexts/userContext';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Search } from '@mui/icons-material';
// import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Shipped_ActiveSVG from 'images/Shipped-Active.svg';
import Delivered_ActiveSVG from 'images/Delivered-Active.svg';
import Failed_ActiveSVG from 'images/Failed-Active.svg';
import Processing_ActiveSVG from 'images/Processing-Active.svg';
import PaginationComponent from './PaginationUserList';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import Consents from './Consents';
import { Colors } from 'pages/SurveyReport/Colors';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DescriptionIcon from '@mui/icons-material/Description';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PaddingOutlinedIcon from '@mui/icons-material/PaddingOutlined';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import {
  AlertCircle,
  Check,
  Clipboard,
  Clock,
  Link,
  Loader2,
  TableIcon,
  Truck,
} from 'lucide-react';
import DeviceCard from 'components/DeviceCard';
// import truckGif from './truck.gif';
import moment from 'moment';
import { message } from 'antd';

const useStyles = makeStyles({
  root: {
    display: 'inline-block',
  },
});

interface UsersListProps {
  readonly users: GetUserListResponse[];
  readonly routes: NavRoutes;
  readonly onUserClick?: (id: number) => void;
  readonly searchPatientData?: (isLoaded?: boolean, body?: any) => void;
  readonly fetchNewDataList: (loadUpdatedData?: boolean) => void;
}

interface AcknowledgementProps {
  device_type: string;
  device_status: string;
  device_imei: string;
}

const UsersList: React.FC<UsersListProps> = ({
  users,
  onUserClick,
  routes,
  fetchNewDataList,
  searchPatientData,
}) => {
  const { isReadOnly, updateClick, setUpdateClick, setUserListingData } =
    useContext<UserContextState>(UserContext);
  const classes = useStyles();
  const intl = useIntl();
  const accessToken = localStorage.getItem('access_token');
  const controller = new AbortController();
  const apiClient = createApiClient(accessToken!, controller);
  const [searchText, setSearchText] = useState<string>('');
  const [localSearchText, setLocalSearchText] = useState<string>('');
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState<boolean>(false);
  const [isAlertsDialogOpen, setIsAlertsDialogOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [selectedUserRole, setSelectedRole] = useState<string>('');
  const [selectedAlertReceiver, setSelectedAlertReceiver] = useState<
    number | null
  >(null);
  const [missingNetwork, setMissingNetwork] = useState<string | boolean>(false);
  const [isRpmSelect, setRpmSelect] = useState<string>('');
  const [filteredUsers, setFilteredUsers] =
    useState<GetUserListResponse[]>(users);
  const [selectedValue, setSelectedValue] = useState('');
  const [deviceStatus, setDeviceStatus] = useState<AcknowledgementProps | null>(
    null,
  );
  const [orderTrackingModal, setOrderTrackingModal] = useState<boolean>(false);
  const [deviceTrackingData, setDeviceTrackingData] = useState<any>();
  const [isPatientEducation, setIsPatientEducation] = useState<boolean>(false);
  const [showToast, setShowToast] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [activeTab, setActiveTab] = useState(0);

  const [consentName, setConsentName] = useState<any>('');
  const [byteString, setByteString] = useState<any>('');
  const [signerType, setSignerType] = useState<any>('');
  const [signType, setSignType] = useState<any>('');
  const [patientExtId, setPatientExtId] = useState<any>('');
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [confirmatiomModal, setConfirmationModal] = useState<boolean>(false);
  const [ackPatientName, setAckPatientName] = useState<string>('');
  const [userType, setUserTpye] = useState<string>('customer_admin');
  const [currLoggedInUser, setCurrLoggedInUser] = useState<any>(
    sessionStorage.getItem('loggedInUser'),
  );
  const [imei, setImei] = useState<string>('');
  const [time, setTime] = useState<string>('');
  const [proccedWIthRPm, setProceedWithRpm] = useState<any>(false);
  const [consentTempData, setconsentTempData] = useState<any>(null);
  const [isConsentUploaded, setIsConsentUploaded] = useState<any>(false);

  const [isConsentModalOpen, setIsConsentModalOpen] = useState<boolean>(false);
  const [isOpenConsentForm, setIsOpenConsentForm] = useState<boolean>(false);
  const [isSelectedConsent, setIsSelectedConsent] = useState<string>('');

  const [currentPage, setCurrentPage] = useState<number>();
  const [currentItems, setCurrentItems] = useState<any>([]);

  const patientIntId = useRef<any>();
  const deviceTrackingId = useRef<any>();

  const { isLoading: isUpdatingAlertStatus, mutate: updateAlertStatus } =
    useMutation(
      'update-alert-status',
      () =>
        apiClient.updateAlertStatus(selectedUserId!, {
          alert_receiver_status: selectedAlertReceiver === 1 ? 0 : 1,
        }),
      {
        onSuccess: () => {
          closeAlertsDialog();
          fetchNewDataList(true);
        },
      },
    );

  const { isLoading: isDeletingUser, mutate: deleteUserFromList } = useMutation(
    'delete-user',
    ({ id, role }: { id: number; role: UserRole }) =>
      apiClient.deleteUser(id, role),
    {
      onSuccess: () => {
        handleMenuClose();
        setSnackbarMessage('Deletion Successful!!');
        handleSnackBarOpen();
        closeDeleteDialog();
        fetchNewDataList(true);
      },
      onError: () => {
        setSnackbarMessage('Deletion Failed!!');
        handleSnackBarClose();
        closeDeleteDialog();
      },
    },
  );

  const {
    isLoading,
    mutate: callPatientList,
    data: patientListData,
  } = useMutation(
    'getUpdatedPatientList',
    () =>
      apiClient.getPatientList(false, {
        rpm: isRpmSelect,
        networks: missingNetwork,
        name: searchText,
        offset: currentPage,
      }),
    {
      onSuccess: (data: any) => {
        setUpdateClick(false);
        // eslint-disable-next-line
        setTotalPageCount(data[1]?.total_count);
        sessionStorage.setItem('ortderType', '');
      },
    },
  );

  const [patientList, setPatientList] = useState<any>();

  useEffect(() => {
    if (patientListData) {
      setPatientList(patientListData[0]);
      setUserListingData(patientListData[0]);
    }
  }, [patientListData]);

  const getRole = (role: UserRole) => {
    if (role === UserRole.patient || role === UserRole.caregiver) {
      return role;
    }
    return UserRole.provider;
  };

  const handleMenuControlClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    id: number,
    role: string,
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedUserId(id);
    setSelectedRole(role);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedUserId(null);
    setSelectedRole('');
  };

  const setDeleteDialogUserData = (id: number, role: string) => {
    setSelectedUserId(id);
    setSelectedRole(role);
    openDeleteDialog();
  };

  const openDeleteDialog = () => setIsDeleteDialogOpen(true);
  const closeDeleteDialog = () => setIsDeleteDialogOpen(false);
  const openAlertsDialog = () => setIsAlertsDialogOpen(true);
  const closeAlertsDialog = () => setIsAlertsDialogOpen(false);
  const alertReceiverStatus = () => updateAlertStatus();

  const alertsDialogOpen = (id: number, alert_receiver: number) => {
    openAlertsDialog();
    setSelectedUserId(id);
    setSelectedAlertReceiver(alert_receiver);
  };

  const username = (item: GetUserListResponse) => {
    if (ProviderProps.degree in item) return `${item.name}, ${item.degree}`;
    else return `${item.last_name}, ${item.first_name}`;
  };

  const specialty = (item: GetUserListResponse) => {
    if (ProviderProps.specialty in item && ProviderProps.groupName in item)
      return `${item.specialty}, ${item.group}`;
    else return ``;
  };

  const alertReceiver = (item: GetUserListResponse) => {
    if (ProviderProps.alert_receiver in item) {
      return item.alert_receiver === 1
        ? Icons.notifications_on
        : Icons.notifications_off;
    }
  };

  const alertReceiverColor = (item: GetUserListResponse) => {
    if (ProviderProps.alert_receiver in item) {
      return item.alert_receiver === 1 ? blue[800] : grey[500];
    }
  };

  const handleSearchTextChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setSearchText(event.target.value);

  const localSearch = (event: React.ChangeEvent<HTMLInputElement>) =>
    setLocalSearchText(event.target.value);

  const deleteUser = () =>
    deleteUserFromList({
      id: selectedUserId!,
      role: getRole(selectedUserRole as UserRole),
    });

  const handleSnackBarOpen = () => setIsSnackbarOpen(true);

  const handleSnackBarClose = () => setIsSnackbarOpen(false);

  const handleSelectMissing = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked === true) {
      setMissingNetwork(true);
    } else {
      setMissingNetwork('');
    }
  };

  const handleSelectRpm = (event: SelectChangeEvent) => {
    if (event.target.value === 'A') {
      setRpmSelect('');
      setSelectedValue(event.target.value);
    } else {
      setRpmSelect(event.target.value);
      setSelectedValue(event.target.value);
    }
  };

  const [data, setData] = useState(
    routes === NavRoutes.patients ? patientList : users,
  );
  useEffect(() => {
    setData(routes === NavRoutes.patients ? patientList : filteredUsers);
  }, [routes, patientList, filteredUsers]);

  useEffect(() => {
    const searchResults =
      !isEmpty(users) && isArray(users)
        ? users.filter((user: GetUserListResponse) =>
            user?.name?.toLowerCase().includes(localSearchText.toLowerCase()),
          )
        : [];
    setFilteredUsers(localSearchText ? searchResults : users);
  }, [localSearchText, users]);

  const sortedOrgList = useMemo(() => {
    if (!data) {
      return;
    }
    const sortedData = [...data].filter(item => item.last_name);
    return sortedData.sort((a: any, b: any) =>
      a.last_name.toLowerCase()?.localeCompare(b.last_name.toLowerCase()),
    );
  }, [data]);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      callPatientList();
    }
  };

  const itemsPerPage = (searchText ? patientList?.length : 25) ?? 25;
  const handlePageChange = (page: any) => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setCurrentItems(sortedOrgList?.slice(startIndex, endIndex));
  };

  useEffect(() => {
    handlePageChange(1);
  }, [sortedOrgList]);

  useEffect(() => {
    callPatientList();
  }, [updateClick, currentPage]);

  const [totalPageCount, setTotalPageCount] = useState<any>();

  //new consent upload

  useEffect(() => {
    filterConsentList();
  }, [isConsentModalOpen]);

  const filterConsentList = () => {
    const filteredItem = currentItems?.filter(
      (item: any) => item.sign_date !== null,
    );
  };

  const {
    isLoading: uploadConsentLoading,
    mutate: uploadConsent,
    data: uploadConsentData,
  } = useMutation(
    [
      consentName,
      byteString,
      signerType,
      signType,
      patientExtId,
      userType,
      ackPatientName,
      currLoggedInUser,
      time,
    ],
    () =>
      consentName &&
      ['device_acknowledgement', 'weight_device_acknowledgement'].includes(
        consentName,
      )
        ? apiClient.postConsent(
            consentName,
            byteString,
            signerType,
            signType,
            patientExtId,
            userType,
            ackPatientName,
            currLoggedInUser,
            deviceStatus?.device_imei,
            time,
            deviceStatus?.device_type,
          )
        : apiClient.postConsent(
            consentName,
            byteString,
            signerType,
            signType,
            patientExtId,
            userType,
            ackPatientName,
            currLoggedInUser,
            selectedUser?.imei,
          ),
    {
      onSuccess: (data: any) => {
        setIsConsentUploaded(true);
        callPatientList();
        setIsPatientEducation(false);

        data?.consents[0]?.consent_name === 'caregem' &&
          setProceedWithRpm(true);
        setIsOpenConsentForm(false);
        setConfirmationModal(false);
        setIsConsentModalOpen(false);
      },
    },
  );

  const {
    isLoading: deviceOrderDataLoading,
    mutate: getDeviceOrder,
    data: deviceOrderData,
  } = useMutation(
    ({ patientId, trackingId }: { patientId: string; trackingId: string }) =>
      apiClient.getDeviceOrderData(patientId, trackingId),
    {
      onSuccess: (data: any) => {
        // console.log('recived->device->delivery-order', data);
      },
    },
  );

  useEffect(() => {
    if (isConsentUploaded)
      if (uploadConsentData) {
        if (patientListData) {
          setIsConsentModalOpen(true);
          // Find and update the selected user if it exists in the new data
          if (selectedUser) {
            const updatedUserData = patientListData[0]?.find(
              (patient: GetUserListResponse) =>
                patient?.id === selectedUser?.id,
            );
            if (updatedUserData) {
              setSelectedUser(updatedUserData);
            }
          }
          setIsConsentUploaded(false);
        }
      }
  }, [uploadConsentData, patientListData]);

  useEffect(() => {
    setconsentTempData(patientListData);
  }, [patientListData]);

  useEffect(() => {
    const placeOrderCheck = localStorage.getItem('placeOrder');
    if (placeOrderCheck === '1') {
      setIsConsentModalOpen(false);
      if (consentTempData) {
        setIsConsentModalOpen(false);
        // Find and update the selected user if it exists in the new data
        if (selectedUser) {
          const updatedUserData = consentTempData[0]?.find(
            (patient: GetUserListResponse) => patient?.id === selectedUser?.id,
          );
          if (updatedUserData) {
            setIsConsentModalOpen(true);
            setSelectedUser(updatedUserData);
          }
        }
        localStorage.setItem('placeOrder', '0');
      }
    }
  }, [consentTempData]);

  const handleCopyTrackingNumber = async () => {
    try {
      if (
        deviceOrderData &&
        deviceOrderData?.bodytrace_orders[0]?.tracking_id
      ) {
        await navigator.clipboard.writeText(
          deviceOrderData && deviceOrderData?.bodytrace_orders[0]?.tracking_id,
        );
        setShowToast(true);
      }
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleCloseToast = () => {
    setShowToast(false);
  };

  const handleChange = (event: any, newValue: any) => {
    const trackingId = deviceTrackingData[newValue].bodytrace_id;
    const patientId = selectedUser?.internal_id;

    deviceTrackingId.current = trackingId;
    setActiveTab(newValue);

    if (trackingId && patientId) {
      getDeviceOrder({ patientId, trackingId });
    }
  };

  useEffect(() => {
    if (activeTab && deviceTrackingData && deviceTrackingData[activeTab]) {
      deviceTrackingId.current = deviceTrackingData[activeTab]?.bodytrace_id;
    }
  }, [activeTab, deviceTrackingData]);

  const fetchByStatus = (logs: any, statusToFind: any) => {
    return logs?.find((log: any) => log?.status === statusToFind);
  };

  const checkDeviceStatusObject = (userData: any) => {
    if (!userData?.bodytrace_orders?.length) {
      return null;
    }
    return userData?.bodytrace_orders?.find(
      (device: any) => device.status === 'Delivered' && !device.signed_date,
    );
  };

  const defineColor = (userData: any) => {
    if (!userData?.bodytrace_orders?.length) {
      return 'gray';
    }
    const firstFound = userData?.bodytrace_orders?.find(
      (device: any) => !device.signed_date,
    );

    // if (userData?.bodytrace_orders?.length === 1 && firstFound) {
    //   return 'gray';
    // }

    return firstFound ? '' : '#16a34a';
  };

  useEffect(() => {
    const matchingDevice = checkDeviceStatusObject(selectedUser);

    if (matchingDevice) {
      if (
        [
          'Blood Pressure',
          'Blood Pressure (Standard)',
          'Blood Pressure (Small)',
          'Blood Pressure (Large)',
          'Blood Pressure (XL)',
          'Blood Pressure (XXL)',
        ].includes(matchingDevice.device_type)
      ) {
        setIsSelectedConsent('device_acknowledgement');
      } else if (
        [
          'Weighing Scale',
          'Weighing Scale (Standard Scale 440 lbs)',
          'Weighing Scale (iScale Plus 550 lbs)',
        ].includes(matchingDevice.device_type)
      ) {
        setIsSelectedConsent('weight_device_acknowledgement');
      }

      setDeviceStatus({
        device_type: matchingDevice.device_type,
        device_status: matchingDevice.status,
        device_imei: matchingDevice.imei,
      });
    }
  }, [selectedUser]);

  function getPatientStatusColor(patient) {
    const caregem = patient.consents.find(
      (c: any) => c.consent_name === 'caregem',
    );
    const rpm = patient.consents.find((c: any) => c.consent_name === 'rpm');

    const bodytraceBP = patient.bodytrace_orders.find(
      (o: any) => o.device_type === 'Blood Pressure',
    );
    const bodytraceWS = patient.bodytrace_orders.find(
      (o: any) => o.device_type === 'Weighing Scale',
    );

    const deviceBP = patient.device_paired.find(
      (d: any) => d.device_type === 'Blood Pressure',
    );
    const deviceWS = patient.device_paired.find(
      (d: any) => d.device_type === 'Weighing Scale',
    );

    if (caregem && !caregem.sign_date) return '#90caf9';
    if (rpm && !rpm.sign_date) return 'rgb(242, 215, 32)';

    const deliveredUnacknowledged = patient.bodytrace_orders.find(
      (o: any) => o.status === 'Delivered' && !o.signed_date,
    );
    if (deliveredUnacknowledged) return 'rgb(242, 215, 32)';
    if (deviceBP && deviceBP.start_date) return 'rgb(76, 175, 80)';
    if (deviceWS && deviceWS.start_date) return 'rgb(76, 175, 80)';
    if (bodytraceBP && bodytraceBP.signed_date) return 'rgb(76, 175, 80)';
    if (bodytraceWS && bodytraceWS.signed_date) return 'rgb(76, 175, 80)';

    return 'rgb(76, 175, 80)';
  }

  function combineDevices(item: any) {
    const combined: Record<string, any> = {};

    (item.bodytrace_orders || []).forEach((order: any) => {
      const type = order.device_type;
      combined[type] = {
        device_type: type,
        source: 'bodytrace',
        status: order.status,
        imei: order.imei,
        signed_date: order.signed_date,
        bodytrace_id: order.bodytrace_id,
        ack_imei: order.ack_imei,
      };
    });

    (item.device_paired || []).forEach((device: any) => {
      const type = device.device_type;
      if (combined[type]) {
        // Merge if already exists from bodytrace
        combined[type] = {
          ...combined[type],
          source: 'both',
          start_date: device.start_date,
          end_date: device.end_date,
          paired_imei: device.imei,
        };
      } else {
        combined[type] = {
          device_type: type,
          source: 'paired',
          start_date: device.start_date,
          end_date: device.end_date,
          paired_imei: device.imei,
          imei: device.imei,
          status: 'Acknowledgement Signed',
        };
      }
    });
    return Object.values(combined).reverse();
  }

  return (
    <div className="fullWidth" onKeyDown={handleKeyPress}>
      {contextHolder}
      <div className="filter-grp">
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            width: '90%',
          }}
        >
          <TextField
            name="noAutoFill"
            style={{
              marginRight: routes === NavRoutes.patients ? 20 : 0,
              width: routes === NavRoutes.patients ? '45%' : '100%',
            }}
            sx={{
              '& .MuiInputBase-root': {
                height: '40px',
              },
            }}
            id="outlined-basic"
            label={
              routes === NavRoutes.patients
                ? 'Search Patient or IMEI'
                : 'Search'
            }
            variant="outlined"
            onChange={
              routes === NavRoutes.patients
                ? handleSearchTextChange
                : localSearch
            }
          />
          {routes === NavRoutes.patients && (
            <>
              <FormControl sx={{ m: 1, minWidth: 140 }} size="small">
                <InputLabel>RPM Enabled</InputLabel>
                <Select
                  value={selectedValue}
                  label="RPM ENABLED"
                  onChange={handleSelectRpm}
                >
                  <MenuItem value={'A'}>All</MenuItem>
                  <MenuItem value={'Y'}>Yes</MenuItem>
                  <MenuItem value={'N'}>No</MenuItem>
                  <MenuItem value={'P,I'}>Pending</MenuItem>
                </Select>
              </FormControl>
            </>
          )}
          {routes === NavRoutes.patients && (
            <>
              <FormControl
                sx={{ m: 1, minWidth: 200 }}
                style={{
                  width: 230,
                  marginTop: 15,
                }}
                size="small"
                className="fullWidth"
              >
                <FormControlLabel
                  control={<Checkbox onChange={handleSelectMissing} />}
                  label="Missing network details"
                />
              </FormControl>
            </>
          )}
        </div>

        {routes === NavRoutes.patients && (
          <FormControl
            sx={{ minWidth: 120 }}
            size="small"
            className="searchButton"
          >
            <Button
              variant="outlined"
              // className="fullHeight"
              startIcon={<Search />}
              onClick={() => {
                callPatientList();
              }}
              style={{ padding: 7 }}
            >
              Search
            </Button>
          </FormControl>
        )}
      </div>

      {/**********************  table starts *********************/}
      <TableContainer className="patientsListing" component={Paper}>
        {isLoading ? (
          <div
            style={{
              width: '100%',
              height: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress color="primary" />
          </div>
        ) : (
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              {routes === NavRoutes.patients ? (
                <TableRow>
                  <TableCell>Patient</TableCell>
                  <TableCell align="center">DOB</TableCell>
                  <TableCell align="center">Consent</TableCell>
                  <TableCell align="center">Device&nbsp;</TableCell>
                  <TableCell align="left">&nbsp;</TableCell>
                </TableRow>
              ) : (
                <TableRow></TableRow>
              )}
            </TableHead>
            <TableBody
              style={{
                cursor: 'pointer',
              }}
              className="table-row"
            >
              {isEmpty(patientList) && isArray(patientList) && (
                <div className="noDataContainer">
                  <div>No Data</div>
                </div>
              )}
              {!isEmpty(patientList) && !isArray(patientList) && (
                <div className="red">Invalid API Response</div>
              )}
              {currentItems?.map(
                (item: any) =>
                  username(item) !== 'undefined' && (
                    <TableRow key={item.id}>
                      <TableCell
                        scope="row"
                        align="center"
                        onClick={() => {
                          onUserClick?.(item.id);
                          setSelectedUser(item);
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyItems: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {item.role !== UserRole.patient &&
                            item.role !== UserRole.caregiver && (
                              <Icon style={{ color: alertReceiverColor(item) }}>
                                {alertReceiver(item)}{' '}
                              </Icon>
                            )}
                          <div style={{ marginRight: 15 }}>
                            {item.network_count! !== 0 ? (
                              item.role !== UserRole.caregiver && (
                                <Icon
                                  style={{
                                    color:
                                      item.remote_monitoring === 'Y'
                                        ? green[500]
                                        : item.remote_monitoring === 'P'
                                        ? '#f2d720'
                                        : item.remote_monitoring === 'I'
                                        ? '#f2d720'
                                        : grey[500],
                                    width: 20,
                                  }}
                                >
                                  {Icons.settings_remote}
                                </Icon>
                              )
                            ) : (
                              <Icon
                                style={{
                                  color: red[500],
                                }}
                              >
                                {Icons.warning}
                              </Icon>
                            )}
                          </div>
                          {username(item)} <br />
                          {specialty(item)}
                        </div>
                      </TableCell>
                      {item.role === UserRole.patient && (
                        <TableCell
                          align="center"
                          onClick={() => onUserClick?.(item.id)}
                        >
                          {item?.dob}
                        </TableCell>
                      )}

                      {item.role === UserRole.patient && (
                        <TableCell align="center">
                          <IconButton
                            onClick={() => {
                              setIsConsentModalOpen(!isConsentModalOpen);
                              setSelectedUser(item);
                              // setDeviceStatus(item?.bodytrace_orders);
                              // filterAcknowledgementConsent(
                              //   item?.bodytrace_orders,
                              // );
                              // filterAckConsent(item.consents);
                            }}
                          >
                            <UploadFileRoundedIcon
                              fontSize="medium"
                              style={{
                                color: getPatientStatusColor(item),
                                backgroundColor: 'transparent',
                              }}
                            />
                          </IconButton>
                        </TableCell>
                      )}

                      {item.role === UserRole.patient && (
                        <TableCell
                          align="center"
                          style={{
                            zIndex: '999',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <>
                            {combineDevices(item).map((device: any) => (
                              <div
                                onClick={() => {
                                  if (!device.bodytrace_id) {
                                    messageApi.info('Device Manual Paired');
                                  }
                                  if (device.bodytrace_id) {
                                    patientIntId.current = item.internal_id;
                                    deviceTrackingId.current =
                                      device.bodytrace_id || '';
                                    setOrderTrackingModal(!orderTrackingModal);
                                    setDeviceTrackingData(
                                      item.bodytrace_orders,
                                    );
                                    getDeviceOrder({
                                      patientId: item.internal_id,
                                      trackingId: device.bodytrace_id || '',
                                    });
                                  }
                                  setSelectedUser(item);
                                  device?.device_type === 'Blood Pressure' ||
                                  'Blood Pressure (Standard)' ||
                                  'Blood Pressure (Small)' ||
                                  'Blood Pressure (Large)' ||
                                  'Blood Pressure (XL)' ||
                                  'Blood Pressure (XXL)'
                                    ? setActiveTab(0)
                                    : setActiveTab(1);
                                }}
                              >
                                <DeviceCard
                                  type={
                                    [
                                      'Weighing Scale',
                                      'Weighing Scale (Standard Scale 440 lbs)',
                                      'Weighing Scale (iScale Plus 550 lbs)',
                                    ].includes(device.device_type)
                                      ? 'Weight'
                                      : [
                                          'Blood Pressure',
                                          'Blood Pressure (Standard)',
                                          'Blood Pressure (Small)',
                                          'Blood Pressure (Large)',
                                          'Blood Pressure (XL)',
                                          'Blood Pressure (XXL)',
                                        ].includes(device.device_type)
                                      ? 'BP'
                                      : ''
                                  }
                                  status={
                                    device.status || 'Acknowledgement Signed'
                                  }
                                  imei={device.imei || device.paired_imei}
                                />
                              </div>
                            ))}
                          </>
                        </TableCell>
                      )}
                      <TableCell align="right">
                        {routes === NavRoutes.patients ||
                        routes === NavRoutes.caregivers ? (
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            disabled={isReadOnly}
                            onClick={() =>
                              setDeleteDialogUserData(item.id, item.role)
                            }
                          >
                            <DeleteIcon />
                          </IconButton>
                        ) : (
                          <>
                            <IconButton
                              edge="end"
                              aria-label="more"
                              disabled={isReadOnly}
                              onClick={e =>
                                handleMenuControlClick(
                                  e,
                                  item.id,
                                  UserRole.provider,
                                )
                              }
                            >
                              <MoreVert />
                            </IconButton>
                            <Menu
                              id="basic-menu"
                              anchorEl={anchorEl}
                              open={selectedUserId === item.id}
                              anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                              }}
                              transformOrigin={{
                                vertical: 'center',
                                horizontal: 'center',
                              }}
                              onClose={handleMenuClose}
                            >
                              <MenuItem onClick={openDeleteDialog}>
                                <ListItemIcon>
                                  <DeleteIcon fontSize="medium" />
                                </ListItemIcon>
                                <ListItemText className="networkUserNameText">
                                  {intl.formatMessage({
                                    id: I18nKey.ARCHIVE_USER,
                                  })}
                                </ListItemText>
                              </MenuItem>
                              <MenuItem
                                onClick={() =>
                                  alertsDialogOpen(
                                    item.id,
                                    item.alert_receiver!,
                                  )
                                }
                              >
                                <ListItemIcon>
                                  <NotificationsIcon fontSize="medium" />
                                </ListItemIcon>
                                {item.alert_receiver === 1 ? (
                                  <ListItemText className="networkUserNameText">
                                    {intl.formatMessage({
                                      id: I18nKey.USER_NETWORK_ACTION_DEACTIVATE_ALERTS,
                                    })}
                                  </ListItemText>
                                ) : (
                                  <ListItemText className="networkUserNameText">
                                    {intl.formatMessage({
                                      id: I18nKey.USER_NETWORK_ACTION_ACTIVATE_ALERTS,
                                    })}
                                  </ListItemText>
                                )}
                              </MenuItem>
                            </Menu>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  ),
              )}
            </TableBody>
          </Table>
        )}
        <>
          <PaginationComponent
            totalItems={totalPageCount}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
            isLoading={isLoading}
            setCurrentPage={setCurrentPage}
            routes={routes}
          />
        </>
      </TableContainer>

      {/**********************  table ends *********************/}

      <Snackbar
        open={isSnackbarOpen}
        autoHideDuration={2000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        onClose={handleSnackBarClose}
        message={snackbarMessage}
      />
      <Dialog open={isDeleteDialogOpen} onClose={closeDeleteDialog} fullWidth>
        <DialogTitle>
          {intl.formatMessage({
            id: I18nKey.ARCHIVE_USER_CONFIRM_DIALOG_TITLE,
          })}
        </DialogTitle>
        <DialogContent>
          {intl.formatMessage({
            id: I18nKey.ARCHIVE_USER_CONFIRM_DIALOG_CONTENT,
          })}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteDialog}>
            {intl.formatMessage({ id: I18nKey.CANCEL })}
          </Button>
          <Button onClick={deleteUser} disabled={isDeletingUser}>
            {isDeletingUser ? (
              <CircularProgress size={30} />
            ) : (
              intl.formatMessage({ id: I18nKey.CONFIRM })
            )}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isAlertsDialogOpen}
        onClose={closeAlertsDialog}
        maxWidth={'lg'}
      >
        <DialogTitle>
          <Icon
            sx={{
              color: 'black',
            }}
          >
            {Icons.warning}
          </Icon>
          {intl.formatMessage({
            id: I18nKey.ALERT_RECEIVER_DIALOG_TITLE,
          })}
        </DialogTitle>
        <DialogContent sx={{ color: 'red' }}>
          <FormattedMessage
            id={I18nKey.ALERT_RECEIVER_DIALOG_CONTENT}
            values={{ separator: <br /> }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeAlertsDialog}>
            {intl.formatMessage({ id: I18nKey.CANCEL })}
          </Button>
          <Button
            onClick={alertReceiverStatus}
            disabled={isUpdatingAlertStatus}
          >
            {isUpdatingAlertStatus ? (
              <CircularProgress size={30} />
            ) : (
              intl.formatMessage({ id: I18nKey.CONFIRM })
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {routes === NavRoutes.patients && (
        <>
          {/* consent modal option */}
          <Dialog
            open={isConsentModalOpen}
            onClose={() => setIsConsentModalOpen(false)}
            maxWidth={'lg'}
            aria-describedby="alert-dialog-slide-description"
            BackdropProps={{
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                backdropFilter: 'blur(4px)',
              },
            }}
          >
            <DialogTitle
              textAlign={'left'}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '20px 31px',
                fontSize: '18px',
                fontWeight: 'bold',
                marginBottom: '10px',
              }}
            >
              <span>
                {selectedUser?.consents[0]?.sign_date === null ||
                selectedUser?.consents[1]?.sign_date === null
                  ? 'SELECT CONSENT'
                  : 'CONSENT STATUS'}
              </span>
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  setIsConsentModalOpen(false);
                  setconsentTempData(null);
                }}
                style={{ padding: '2px 2px' }}
              >
                CLOSE
              </Button>
            </DialogTitle>
            <DialogContent>
              <div
                style={{
                  gap: 20,
                  padding: 5,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {/* Caregem Consent Button */}
                <Button
                  variant="contained"
                  onClick={() => {
                    setIsOpenConsentForm(!isOpenConsentForm);
                    setIsSelectedConsent('caregem');
                  }}
                  disabled={
                    selectedUser?.consents?.[0]?.sign_date !== null
                      ? true
                      : false
                  }
                  style={{
                    backgroundColor:
                      selectedUser?.consents?.[0]?.sign_date !== null
                        ? selectedUser?.consents?.length > 0
                          ? '#16a34a'
                          : 'grey'
                        : '',
                    color: 'white',
                    padding: '10px 100px',
                    borderRadius: '8px',
                  }}
                >
                  <span
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 4,
                    }}
                  >
                    {selectedUser?.consents?.[0]?.sign_date !== null ? (
                      <CheckCircleIcon style={{ width: 80 }} />
                    ) : (
                      <DescriptionIcon style={{ width: 80 }} />
                    )}
                    {`Caregem Consent ${
                      selectedUser?.consents?.[0]?.sign_date !== null
                        ? 'Signed'
                        : ''
                    }`}
                  </span>
                </Button>

                {/* RPM Consent BUtton */}
                <Button
                  variant="contained"
                  onClick={() => {
                    if (
                      selectedUser &&
                      selectedUser?.consents?.[1]?.sign_date !== null
                    ) {
                      onUserClick?.(selectedUser?.id);
                    } else {
                      setIsSelectedConsent('rpm');
                      setIsOpenConsentForm(!isOpenConsentForm);
                    }
                  }}
                  disabled={
                    !selectedUser?.consents ||
                    selectedUser?.consents?.length === 1
                      ? false
                      : selectedUser?.consents?.[1]?.sign_date !== null
                      ? true
                      : false
                  }
                  style={{
                    backgroundColor:
                      selectedUser?.consents?.[1]?.sign_date !== null
                        ? selectedUser?.consents?.length > 1
                          ? '#16a34a'
                          : ''
                        : '',
                    color: 'white',
                    padding: '10px 100px',
                    borderRadius: '8px',
                  }}
                >
                  <span
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 4,
                    }}
                  >
                    {selectedUser && selectedUser?.consents?.length === 1 ? (
                      <WatchLaterOutlinedIcon
                        style={{ fontSize: '26px', marginTop: '-2px' }}
                      />
                    ) : selectedUser?.consents?.[1]?.sign_date === null ? (
                      <DescriptionIcon style={{ width: 80 }} />
                    ) : (
                      <CheckCircleIcon style={{ width: 80 }} />
                    )}
                    {selectedUser && selectedUser?.consents?.length === 1
                      ? 'Continue with RPM Initiation'
                      : selectedUser?.consents?.[1]?.sign_date === null
                      ? 'RPM Consent'
                      : 'RPM Consent Signed'}
                  </span>
                </Button>

                {/* Device Acknowledgement Button */}
                <Button
                  variant="contained"
                  onClick={() => {
                    setIsOpenConsentForm(!isOpenConsentForm);
                  }}
                  disabled={
                    checkDeviceStatusObject(selectedUser)?.status ===
                      'Delivered' &&
                    !checkDeviceStatusObject(selectedUser)?.signed_date
                      ? false
                      : true
                  }
                  style={{
                    backgroundColor: defineColor(selectedUser),

                    color: 'white',
                    padding: '10px 50px',
                    borderRadius: '8px',
                  }}
                >
                  <span
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 4,
                    }}
                  >
                    {' '}
                    {defineColor(selectedUser) === 'gray' ? (
                      <DescriptionIcon style={{ width: 80 }} />
                    ) : defineColor(selectedUser) === '' ? (
                      <DescriptionIcon style={{ width: 80 }} />
                    ) : (
                      <CheckCircleIcon style={{ width: 80 }} />
                    )}
                    <span>
                      Device Acknowledgement{' '}
                      {checkDeviceStatusObject(selectedUser)?.status ===
                        'Delivered' &&
                        !checkDeviceStatusObject(selectedUser)?.signed_date &&
                        deviceStatus?.device_type}
                    </span>
                  </span>
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          {/*Consent Form modal option */}
          <Dialog
            open={isOpenConsentForm}
            onClose={() => setIsOpenConsentForm(false)}
            fullWidth={true}
            maxWidth={'md'}
            aria-describedby="alert-dialog-slide-description"
            BackdropProps={{
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                backdropFilter: 'blur(10px)',
              },
            }}
          >
            <DialogTitle textAlign={'left'}>
              {isSelectedConsent === 'caregem'
                ? 'CAREGEM CONSENT'
                : isSelectedConsent === 'rpm'
                ? 'RPM CONSENT'
                : 'Device Acknowledgement'}
            </DialogTitle>
            <DialogContent>
              <Consents
                selectedConsent={isSelectedConsent}
                setConsentName={setConsentName}
                setByteString={setByteString}
                setSignerType={setSignerType}
                setSignType={setSignType}
                setPatientExtId={setPatientExtId}
                selectedUser={selectedUser}
                byteString={byteString}
                setAckPatientName={setAckPatientName}
                setImei={setImei}
                setTime={setTime}
                deviceStatus={deviceStatus}
                setIsPatientEducation={setIsPatientEducation}
                isPatientEducation={isPatientEducation}
              />
            </DialogContent>
            <DialogActions
              style={{
                width: '100%',
                paddingTop: 20,
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={() => setIsOpenConsentForm(!isOpenConsentForm)}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={() => setConfirmationModal(!confirmatiomModal)}
                disabled={
                  isSelectedConsent === 'device_acknowledgement' ||
                  isSelectedConsent === 'weight_device_acknowledgement'
                    ? !ackPatientName ||
                      !signerType ||
                      !isPatientEducation ||
                      isLoading
                    : !byteString || !signerType || isLoading
                }
              >
                {uploadConsentLoading ? (
                  <CircularProgress size={24} />
                ) : (
                  'Submit'
                )}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={confirmatiomModal}
            onClose={() => setConfirmationModal(!confirmatiomModal)}
            fullWidth={true}
            maxWidth={'xs'}
            aria-describedby="alert-dialog-slide-description"
            BackdropProps={{
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                backdropFilter: 'blur(4px)',
              },
            }}
          >
            <DialogTitle textAlign={'center'}>
              For Practice Admin use only
            </DialogTitle>
            <DialogContent
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={() => uploadConsent()}
                disabled={
                  isSelectedConsent === 'device_acknowledgement' ||
                  isSelectedConsent === 'weight_device_acknowledgement'
                    ? !ackPatientName ||
                      !signerType ||
                      !isPatientEducation ||
                      isLoading
                    : !byteString || !signerType || isLoading
                }
              >
                {uploadConsentLoading ? (
                  <CircularProgress size={24} />
                ) : (
                  'Confirm Consent'
                )}
              </Button>
            </DialogContent>
          </Dialog>

          {/* Device Tracking Order Popup */}
          <Dialog
            open={orderTrackingModal}
            fullWidth={true}
            maxWidth={'lg'}
            onClose={() => {
              setOrderTrackingModal(!orderTrackingModal);
              setSelectedUser(null);
            }}
          >
            <DialogContent>
              <Paper elevation={0} sx={{ position: 'relative' }}>
                <AppBar position="static" color="transparent" elevation={0}>
                  <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    sx={{
                      '& .MuiTab-root': {
                        fontSize: '1rem',
                        py: 2,
                      },
                    }}
                    style={{ display: 'flex', justifyItems: 'space-between' }}
                  >
                    {deviceTrackingData &&
                      deviceTrackingData?.map((item: any) => (
                        <Tab label={item?.device_type} />
                      ))}
                    <IconButton
                      style={{
                        marginLeft: '94%',
                        marginTop: '5px',
                        position: 'absolute',
                      }}
                      onClick={() => setOrderTrackingModal(!orderTrackingModal)}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tabs>
                </AppBar>
                <Paper elevation={5} sx={{ position: 'relative' }}>
                  <Box sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', gap: 4 }}>
                      {/* Main Content */}
                      <Box sx={{ flex: 1 }}>
                        {/* Tracking Number Section */}
                        <Card sx={{ mb: 4 }}>
                          <CardContent>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                              }}
                            >
                              <Box>
                                <Typography
                                  variant="subtitle2"
                                  color="text.secondary"
                                  gutterBottom
                                >
                                  Tracking Number
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontFamily="monospace"
                                >
                                  {deviceOrderDataLoading
                                    ? 'Loading...'
                                    : (deviceOrderData &&
                                        deviceOrderData?.bodytrace_orders[0]
                                          ?.tracking_id) ??
                                      'not available'}
                                </Typography>
                              </Box>
                              <IconButton
                                onClick={handleCopyTrackingNumber}
                                size="small"
                              >
                                <Clipboard />
                              </IconButton>
                            </Box>
                          </CardContent>
                        </Card>

                        {/* Track Order Button */}
                        <Button
                          variant="outlined"
                          startIcon={<Truck />}
                          sx={{ mb: 4 }}
                          href="https://www.ups.com/track?loc=en_US&requester=ST/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ width: '100%' }}
                        >
                          Click here to track order&nbsp;&nbsp;&nbsp;
                          <Link />
                        </Button>
                      </Box>

                      <Card sx={{ width: 440 }}>
                        <CardContent>
                          {/* Order History */}
                          <Typography variant="h6" gutterBottom>
                            Device Logs
                          </Typography>
                          <Divider sx={{ mb: 2 }} />

                          {/* Device Logs */}
                          <div
                            style={{
                              height: '50vh',
                              overflowX: 'auto',
                            }}
                          >
                            {deviceOrderDataLoading
                              ? 'Loading...'
                              : deviceOrderData &&
                                deviceOrderData?.logs?.map((item: any) => (
                                  <Paper
                                    variant="outlined"
                                    sx={{ p: 2, bgcolor: 'grey.50', mt: 1.2 }}
                                  >
                                    <Box>
                                      <Typography
                                        variant="body2"
                                        color="text.primary"
                                        sx={{ mb: 0.5 }}
                                      >
                                        {item?.status}
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        {moment(item?.created_date).format(
                                          'MMM DD, YYYY',
                                        )}
                                      </Typography>
                                    </Box>
                                  </Paper>
                                ))}
                          </div>
                        </CardContent>
                      </Card>

                      {/* Order Details Sidebar */}
                      <Card sx={{ width: 250 }}>
                        <CardContent>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              mb: 1,
                            }}
                          >
                            <Typography variant="h6">Order Details</Typography>
                          </Box>
                          <Divider sx={{ mb: 2 }} />

                          <Box sx={{ mb: 2 }}>
                            <Typography
                              variant="subtitle2"
                              color="text.secondary"
                            >
                              Patient Name
                            </Typography>
                            <Typography variant="body1">
                              {deviceOrderDataLoading ? (
                                'Loading...'
                              ) : (
                                <>{selectedUser?.name}</>
                              )}
                            </Typography>
                          </Box>

                          <Box sx={{ mb: 2 }}>
                            <Typography
                              variant="subtitle2"
                              color="text.secondary"
                            >
                              Device ID
                            </Typography>
                            <Typography variant="body1" fontFamily="monospace">
                              {deviceOrderDataLoading
                                ? 'Loading...'
                                : (deviceOrderData &&
                                    deviceOrderData?.bodytrace_orders[0]
                                      ?.imei) ??
                                  'not available'}
                            </Typography>
                          </Box>
                          <Box sx={{ mb: 2 }}>
                            <Typography
                              variant="subtitle2"
                              color="text.secondary"
                            >
                              Date of Placing Order
                            </Typography>
                            <Typography variant="body1">
                              {deviceOrderDataLoading
                                ? 'Loading...'
                                : moment(
                                    fetchByStatus(
                                      deviceOrderData && deviceOrderData?.logs,
                                      'Device order submitted to BodyTrace',
                                    )?.created_date,
                                  )?.format('MMM DD, YYYY')}
                            </Typography>
                          </Box>

                          {/* <Button variant="outlined" fullWidth>
                          View Full Details
                        </Button> */}
                        </CardContent>
                      </Card>
                    </Box>
                  </Box>
                </Paper>
              </Paper>

              <Snackbar
                open={showToast}
                autoHideDuration={2000}
                onClose={handleCloseToast}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <Alert
                  onClose={handleCloseToast}
                  severity="success"
                  sx={{ width: '100%' }}
                >
                  Tracking ID copied successfully!
                </Alert>
              </Snackbar>
            </DialogContent>
          </Dialog>
        </>
      )}
    </div>
  );
};

export default UsersList;
